module.exports = __webpack_public_path__ + "img/SIDEBAR_home.3af9f600.svg";